import { WebUiScopesConfigurationKeyType } from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";

export const useBooleanWebUiScopeMap = () => {
  const org = useGetOrg();
  return org.data.org.configurations.reduce(
    (acc, config) => {
      if (
        config.topic === "WEB_UI_SCOPE" &&
        typeof config.value === "boolean"
      ) {
        acc[config.key] = config.value;
      }
      return acc;
    },
    {} as Record<Lowercase<WebUiScopesConfigurationKeyType>, boolean>
  );
};
